import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import LoginPage from "../../features/auth/LoginPage";
import DashboardPage from "../../features/dashboard/DashboardPage";
import DashboardTemplateList from "../../features/dashboard/pages/DashboardTemplateList";
import DashboardTemplateEditor from "../../features/dashboard/pages/DashboardTemplateEditor";
import { BusinessDashboardPage } from "../../features/businessDashboard";
import NotificationCenterPage from "../../features/workspace/NotificationCenter";
import UserList from "../../features/userManagement/UserList";
import RoleList from "../../features/userManagement/RoleList";
import PermissionList from "../../features/userManagement/PermissionList";
import OrganizationManagement from "../../features/userManagement/OrganizationManagement";
import AuditLogPage from "../../features/auditLog/AuditLogPage";
import { ScreenControlPage, ScreenLeftPage, ScreenRightPage } from "../../features/operationScreen";
import TemplateDrivenDemoPage from "../../features/emailEditorTest/TemplateDrivenDemoPage";
import SankeyFlowDemo from "../../pages/SankeyFlowDemo";
import { FlightMonitorDemoPage, FlightMonitorPage } from "../../features/flightOperation";
import { FlightListPage as RampChecklistFlightListPage, ChecklistPage as RampChecklistPage } from "../../features/rampChecklist";
import AirportList from "../../features/masterData/Airport/AirportList";
import FlightLegList from "../../features/masterData/FlightLeg/FlightLegList";
import { FlightRouteList } from "../../features/masterData/FlightRoute";
import AircraftList from "../../features/masterData/Aircraft/AircraftList";
import { EmailTemplateList } from "../../features/masterData/EmailTemplate";
import { EmailGroupList } from "../../features/masterData/EmailGroup";
import { ExchangeRateList } from "../../features/masterData/ExchangeRate";
import { MeasurementUnitList } from "../../features/masterData/MeasurementUnit";
import { ScenarioContextList } from "../../features/agent/scenarioContext";
import { AgentVariantRuleList } from "../../features/agent/agentVariant";
import { RelationshipDashboardRedirect } from "../../features/masterData/RelationshipDashboard";
import { BusinessPartnerList, ProductList, SupplierContractItemsPage, SupplierContractsRedirect, ProductBundleList, FuelPriceWorkbench, MarketReferencePrice, VendorCrmEntryRedirect, VendorCrmDetailRedirect } from "../../features/contractManagement";
import { MawbStockListPage, MawbStockDetailPage } from "../../features/mawbManagement";
import { OutboxList, AutoForwardList } from "../../features/mailbox";
import SalesIataFuelPricePage from "../../features/sales/IataFuelPrice/SalesIataFuelPricePage";
import SalesCargoReportPage from "../../features/sales/CargoReport/SalesCargoReportPage";
import CargoReportArchivePage from "../../features/sales/CargoReport/CargoReportArchivePage";
import SalesRevenueManagementPage from "../../features/sales/RevenueManagement/SalesRevenueManagementPage";
import LegacyScheduleDraftList from "../../features/flightSchedule/DraftList/ScheduleDraftList";
import ScheduleOfficialList from "../../features/flightSchedule/OfficialList/ScheduleOfficialList";
import ScheduleEditor from "../../features/flightSchedule/ScheduleEditor/ScheduleEditorPage";
import { ScheduleDraftEditorPage, ScheduleDraftListPage } from "../../features/flightSchedule/ScheduleDraft";
import { OperationControlPage } from "../../features/operationControl";
import AgReviewPage from "../../features/agentGovernance/review/AgReviewPage";
import PermitRequestList from "../../features/flightOperation/PermitRequest/PermitRequestList";
import { ActionItemList } from "../../features/actionItemManagement";
import { FlightMapPage } from "../../features/flightTracker";
import { UldManagement, UcmManagement, UldOcrManagement } from "../../features/uld";
import { UldTagManagementPage } from "../../features/uld/UldTagManagement";
import { UldHistoryPage } from "../../features/uld/UldHistory";
import { UldStatisticsPage } from "../../features/uld/UldStatistics";
import UldStockAlertPage from "../../features/uld/StockAlert/UldStockAlertPage";
import { InvoiceDataSourcePage, LegCostHubPage, FlightCostManagementPage, SalesRouteManagementPage, ProfitReportManagementPage, BatchCalculationListPage, BatchCalculationCreatePage, BatchCalculationDetailPage, StatisticsDashboardPage, FuelReportPage, ExternalCrawlConfigPage } from "../../features/settlement";
import { FlightCostWorkbenchPage } from "../../features/settlement/FlightCostWorkbench";
import { LegDetailPage } from "../../features/settlement/LegDetail";
import { WorkbenchRouter, ApInvBatchListPage } from "../../features/settlement/APReconciliationWorkbench";
import InvoiceList from "../../features/settlement/InvoiceList/InvoiceList";
import { FlightRecordLogPage } from "../../features/settlement/FlightRecordLog";
import { MarketIntelligenceDocumentPage, MarketIntelligenceEntityPage, MarketIntelligencePage } from "../../features/marketIntelligence";
import { AirportDepartureBoardPage } from "../../features/airportDeparture";
import { MailboxListPage, MailboxDetailPage } from "../../features/mailHub/mailHubControlPlane";
import { ClassificationGovernancePage } from "../../features/mailHub/classificationGovernance";
import { InboxDetailPage, InboxListPage } from "../../features/mailHub/inbox";
import { OutboxListPage } from "../../features/mailHub/outbox";
import { PipelineGovernancePage } from "../../features/mailHub/pipelineGovernance";
import { WorkItemDetailPage, WorkItemListPage } from "../../features/mailHub/workItems";
import { ROUTE_LAYOUTS } from "./schema";

const LEGACY_SECTION_PATHS = {
    routes: "/sales/routes",
    contracts: "/sales/charter-contracts",
    receivables: "/sales/receivables",
    fuel: "/sales/iata-fuel-prices",
};

const SalesRevenueLegacyRedirect = () => {
    const { search } = useLocation();
    const section = new URLSearchParams(search).get("section");
    return React.createElement(Navigate, { to: LEGACY_SECTION_PATHS[section] || "/sales/routes", replace: true });
};

function element(Component, props) {
    return React.createElement(Component, props);
}

export const routeElementMap = {
    dashboard: element(DashboardPage),
    businessDashboard: element(BusinessDashboardPage),
    notificationCenter: element(NotificationCenterPage),
    users: element(UserList),
    roles: element(RoleList),
    permissions: element(PermissionList),
    organizations: element(OrganizationManagement),
    auditLogs: element(AuditLogPage),
    dashboardTemplates: element(DashboardTemplateList),
    dashboardTemplateEditor: element(DashboardTemplateEditor),
    screenControl: element(ScreenControlPage),
    marketIntelligence: element(MarketIntelligencePage),
    marketIntelligenceDocument: element(MarketIntelligenceDocumentPage),
    marketIntelligenceEntity: element(MarketIntelligenceEntityPage),
    airportDepartureBoard: element(AirportDepartureBoardPage),
    flightMonitorDemo: element(FlightMonitorDemoPage),
    rampChecklist: element(RampChecklistFlightListPage),
    rampChecklistDetail: element(RampChecklistPage),
    sankeyFlowDemo: element(SankeyFlowDemo),
    templateDrivenEmailDemo: element(TemplateDrivenDemoPage),
    airports: element(AirportList),
    flightRoutes: element(FlightRouteList),
    flightLegs: element(FlightLegList),
    aircraft: element(AircraftList),
    emailTemplates: element(EmailTemplateList),
    emailGroups: element(EmailGroupList),
    products: element(ProductList),
    measurementUnits: element(MeasurementUnitList),
    productBundles: element(ProductBundleList),
    exchangeRates: element(ExchangeRateList),
    scenarioContextList: element(ScenarioContextList),
    agentVariantRuleList: element(AgentVariantRuleList),
    businessPartners: element(BusinessPartnerList),
    supplierContracts: element(SupplierContractsRedirect),
    supplierContractDetail: element(SupplierContractsRedirect),
    supplierContractItems: element(SupplierContractItemsPage),
    relationshipDashboard: element(RelationshipDashboardRedirect),
    fuelPriceManagement: element(FuelPriceWorkbench),
    marketReferencePriceManagement: element(MarketReferencePrice),
    vendorCrm: element(VendorCrmEntryRedirect, { message: "正在打开新的供应商 CRM…" }),
    vendorCrmCreate: element(VendorCrmEntryRedirect, { message: "正在打开新的新建供应商…" }),
    vendorCrmAlerts: element(VendorCrmEntryRedirect, { message: "正在打开新的供应商预警…" }),
    vendorCrmDetail: element(VendorCrmDetailRedirect),
    mawbStock: element(MawbStockListPage),
    mawbStockDetail: element(MawbStockDetailPage),
    outbox: element(OutboxList),
    autoForward: element(AutoForwardList),
    salesRevenueManagementLegacy: element(SalesRevenueLegacyRedirect),
    salesRevenueRoutes: element(SalesRevenueManagementPage, { initialSection: "routes" }),
    salesRevenueContracts: element(SalesRevenueManagementPage, { initialSection: "contracts" }),
    salesReceivables: element(SalesRevenueManagementPage, { initialSection: "receivables" }),
    salesCargoReport: element(SalesCargoReportPage),
    salesCargoReportArchive: element(CargoReportArchivePage),
    salesIataFuelPrices: element(SalesIataFuelPricePage),
    salesExternalCrawlConfigLegacy: element(Navigate, { to: "/settlement/external-crawl-config", replace: true }),
    schedulesEditor: element(ScheduleEditor),
    scheduleEditorRedirect: element(Navigate, { to: "/flightSchedule/editor/new", replace: true }),
    scheduleEditorDetail: element(ScheduleEditor),
    schedulesLegacyDrafts: element(LegacyScheduleDraftList),
    schedulesDrafts: element(ScheduleDraftListPage),
    scheduleDraftDetail: element(ScheduleDraftEditorPage),
    schedulesList: element(ScheduleOfficialList),
    flightMonitor: element(FlightMonitorPage),
    operationControlV2: element(OperationControlPage),
    agReviewPage: element(AgReviewPage),
    permitRequestList: element(PermitRequestList),
    actionItemList: element(ActionItemList),
    screenLeft: element(ScreenLeftPage),
    screenRight: element(ScreenRightPage),
    flightMap: element(FlightMapPage),
    uldManagement: element(UldManagement),
    ucmManagement: element(UcmManagement),
    uldStatistics: element(UldStatisticsPage),
    uldTagManagement: element(UldTagManagementPage),
    uldHistory: element(UldHistoryPage),
    uldStockAlert: element(UldStockAlertPage),
    uldOcrManagement: element(UldOcrManagement),
    apBatches: element(ApInvBatchListPage),
    apWorkbench: element(WorkbenchRouter),
    invoiceDataSources: element(InvoiceDataSourcePage),
    invoices: element(InvoiceList),
    salesRoutes: element(SalesRouteManagementPage),
    batchCalculations: element(BatchCalculationListPage),
    batchCalculationCreate: element(BatchCalculationCreatePage),
    batchCalculationDetail: element(BatchCalculationDetailPage),
    profitReports: element(ProfitReportManagementPage),
    legCostManagement: element(LegCostHubPage),
    costAllocationLegacy: element(Navigate, { to: "/settlement/leg-cost?tab=cost-allocation", replace: true }),
    acmiEntryLegacy: element(Navigate, { to: "/settlement/leg-cost?tab=acmi", replace: true }),
    commissionEntryLegacy: element(Navigate, { to: "/settlement/leg-cost?tab=commission", replace: true }),
    statisticsDashboard: element(StatisticsDashboardPage),
    fuelReports: element(FuelReportPage),
    flightCostManagementWorkbench: element(FlightCostWorkbenchPage),
    flightCostManagement: element(FlightCostManagementPage),
    legDetail: element(LegDetailPage),
    flightRecordLog: element(FlightRecordLogPage),
    settlementExternalCrawlConfig: element(ExternalCrawlConfigPage),
    mailHubMailboxes: element(MailboxListPage),
    mailHubMailboxDetail: element(MailboxDetailPage),
    mailHubInbox: element(InboxListPage),
    mailHubInboxDetail: element(InboxDetailPage),
    mailHubThreadDetail: element(InboxDetailPage),
    mailHubOutbox: element(OutboxListPage),
    mailHubClassificationGovernance: element(ClassificationGovernancePage),
    mailHubPipelineGovernance: element(PipelineGovernancePage),
    mailHubWorkItems: element(WorkItemListPage),
    mailHubWorkItemDetail: element(WorkItemDetailPage),
    login: element(LoginPage),
    root: null,
};

export const routeRuntimeOverrides = {
    businessDashboard: { layout: ROUTE_LAYOUTS.FULLSCREEN },
    rampChecklist: { layout: ROUTE_LAYOUTS.MOBILE },
    rampChecklistDetail: { layout: ROUTE_LAYOUTS.MOBILE },
    scheduleEditorRedirect: { layout: ROUTE_LAYOUTS.PUBLIC, requiresAuth: false },
    screenLeft: { layout: ROUTE_LAYOUTS.FULLSCREEN },
    screenRight: { layout: ROUTE_LAYOUTS.FULLSCREEN },
    flightMap: { layout: ROUTE_LAYOUTS.FULLSCREEN },
    login: { layout: ROUTE_LAYOUTS.PUBLIC, requiresAuth: false },
};
